import { GetProgrammaticCampaignVideoCompletionRateRO } from "@intentsify/dto";
import { apiService, Endpoints } from "api";
import { DisplayPerformanceFilters } from "screens/CampaignPacing/screens/DisplayPerformance";

export const getVideoCompletionRate = async (
  id: string,
  filters: DisplayPerformanceFilters
): Promise<GetProgrammaticCampaignVideoCompletionRateRO> => {
  const { data } =
    await apiService.get<GetProgrammaticCampaignVideoCompletionRateRO>(
      Endpoints.ProgrammaticCampaigns.CreativeEngagement.Get.VideoCompletionRate(
        id
      ),
      {
        params: {
          yearFrom: filters.yearFrom,
          yearTo: filters.yearTo,
          weekFrom: filters.weekFrom,
          weekTo: filters.weekTo,
        },
      }
    );
  return data;
};
